import { AuthHandler } from './auth';

// Pin the singleton on globalThis so that if this module ends up evaluated
// more than once in a page (host bundle + UMD/remote, dual chunk graphs,
// CJS/ESM interop, etc.) every evaluation reuses the same instance. Without
// this, callers that set the token on one copy never satisfy callers reading
// it from another, producing requests without an Authorization header.
type AuthHandlerGlobal = typeof globalThis & {
  __cmx_authHandler?: AuthHandler;
};

const g = globalThis as AuthHandlerGlobal;

const _authHandler: AuthHandler =
  g.__cmx_authHandler ?? (g.__cmx_authHandler = new AuthHandler());

/**
 * Returns the shared auth handler instance pinned on `globalThis`. Request
 * helpers read through this accessor so that a later `setAuthHandler` call is
 * observed even after this module's initial evaluation.
 */
export function getAuthHandler(): AuthHandler {
  return g.__cmx_authHandler ?? (g.__cmx_authHandler = new AuthHandler());
}

/**
 * Replaces the shared `globalThis.__cmx_authHandler` singleton used by
 * client-api request helpers.
 */
export const setAuthHandler = (authHandler: AuthHandler) => {
  g.__cmx_authHandler = authHandler;
};

export default _authHandler;
